import { doc, setDoc, updateDoc } from "firebase/firestore"
import { useState } from "react"
import { FiChevronRight } from "react-icons/fi"
import { useRecoilState } from "recoil"
import { currectOrderAtom } from "../config/atoms"
import { db } from "../config/firebase"
import { ChargeTransaction, RefundTransaction } from "../functions/metter"
import "./orderpreview.css"

export default function OrderPreview({ connectDevice, printOrder, incoming, printer, setLoading, curValue }) {


    const [currentOrder] = useRecoilState(currectOrderAtom)
    const [confirmClose, setConfirmClose] = useState(false)

    function getColor() {
        switch (currentOrder?.status) {
            case "Cancelled":
                return {
                    color: 'var(--errorColor)',
                }
            case "orderready":
            case "Accepted":
            case "Closed": 
                return {
                    color: 'var(--successColor)',
                }
            default:
                return {
                    color: 'var(--warnColor)'
                }
        }
    }

    async function onCancelOrder() {


        try {

            setLoading(true)
            setConfirmClose(null)

            const status = "cancelled"
            const data = { ...currentOrder, status }
            await setDoc(doc(db, `orders/${currentOrder.id}`), {
                status,
                data
            }, { merge: true })
            await RefundTransaction(curValue - 1)
            window.alert("Order cancelled")
            // notify(order.user, "Order Update", "Your order is " + status, {})
            setLoading(false)

        } catch(err) {
            window.alert("Error closing order: " + err?.response?.data?.message)
            setLoading(false)
        }

    }

    async function closeOrder() {
      
        try {

            setConfirmClose(null)
            setLoading(true)

            // await axios.post("/provider/close/" + order.id, {})
            const status = (currentOrder?.status === "accepted") ? "orderready" : (currentOrder?.status === "orderready") ? "closed" : "cancelled"
            const data = { ...currentOrder, status }

            await setDoc(doc(db, `orders/${currentOrder?.id}`), {
                status,
                deliveryStatus: (status === "orderready" && currentOrder?.type === "delivery") ? "closed-delivery" : "",
                data
            }, { merge: true })
            window.alert("order updated")
            setLoading(false)
            // notify(order.user, "Order Update", "Your order is " + (status === "orderready" ? "in prep" : status), {})

        } catch(err) {
            window.alert("Error closing order: " + err?.response?.data?.message)
            setLoading(false)
        }
    }

    async function acceptOrder() {
        try {
 
            setConfirmClose(null)
            setLoading(true)

            const data = await { ...currentOrder, status: "accepted" }
            await ChargeTransaction(curValue + 1)
            
            await updateDoc(doc(db, `orders/${currentOrder.id}`), {
                status: "accepted",
                data
            })


            setLoading(false)
            window.alert("order updated")
          
        } catch(err) {
            window.alert("Error accepting order: " + err?.response?.data?.message)
            setLoading(false)
        }
    }

    async function rejectOrder() {
        try {

            setConfirmClose(null)
            setLoading(true)

            const data = { ...currentOrder, status: "rejected" }
            await updateDoc(doc(db, `orders/${currentOrder.id}`), {
                status: "rejected",
                data
            })

            window.alert("order rejected")
            setLoading(false)
            
        } catch(err) {
            window.alert("Error accepting order: " + err?.response?.data?.message)
            setLoading(false)
        }
    }
    
    return (
        <>
            {!incoming && <div id="bt-connect-wrapper">
                <button onClick={() => connectDevice()}>Connect Printer</button>
                <button disabled={!printer} onClick={() => printOrder()}>Print Order</button>
            </div>}
            {!!currentOrder && <div id="order-wrapper" style={{ borderLeftColor: getColor().color }} className="card">
                <div className="order-header">
                    <p style={{ fontSize: 20, fontWeight: "bold"  }}>{currentOrder?.title}</p>
                    <p>{currentOrder?.phone}</p>
                </div>
                <br />
                {currentOrder?.items?.map(c => (
                    <div className="item-wrapper" key={"item-" + c}>
                        <div className="card-item">
                            <p className="item-details"> <FiChevronRight size={20} /> {c.quantity} x {c.title}</p>
                            <p className="item-details">{Number(c.price).toFixed(2)}</p>
                        </div>
                        {c?.sources?.length > 0 && (
                            <p className="item-souces">({c?.sources?.join(", ")})</p>
                        )}
                    </div>
                ))}
                <div style={{ marginTop: 25 }} className="order-details-wrapper">
                    <div className="order-details">
                        <p>Delivery Charge</p>
                        <p>R{Number(currentOrder?.deliveryCharge || 0).toFixed(2)}</p>
                    </div>
                    <div className="order-details">
                        <p>Change</p>
                        <p>R{(Number(currentOrder?.amountInHand || currentOrder?.total || 0) - Number(currentOrder?.total || 0)).toFixed(1)}</p>
                    </div>
                </div>
                <div className="order-details-wrapper">
                    <div className="order-details">
                        <p>Delivery Method</p>
                        <p>{currentOrder?.type}</p>
                        <p className="item-souces">{currentOrder?.note}</p>
                    </div>
                    <div className="order-details">
                        <p>Payment Method</p>
                        <p>{currentOrder?.payment}</p>
                    </div>
                </div>
                <div className="totals-wrapper">
                    <p className="total-label">Total</p>
                    <div className="total-value-wrapper">
                        <p className="total-value">R{Number(currentOrder?.total).toFixed(2)}</p>
                    </div>
                </div>
            </div>}
            {!!currentOrder && (incoming ? <div id="bt-connect-wrapper">
                <button 
                    onClick={() => rejectOrder()}
                    style={{ backgroundColor: "var(--errorColor)", color: "#FFF", padding: '15px 0'}}
                >
                    Reject Order
                </button>
                <button 
                    style={{ backgroundColor: "var(--successColor)", color: "#FFF", padding: '15px 0'}}
                    onClick={() => acceptOrder()}
                >
                    Accept Order
                </button>
            </div> :(
                <div id="bt-connect-wrapper">
                    <button 
                        onClick={() => setConfirmClose("cancel")}
                        disabled={currentOrder?.status === "cancelled" || currentOrder?.status === "rejected"}
                        style={{ backgroundColor: "var(--errorColor)", color: "#FFF", padding: '15px 0'}}
                    >
                        Cancel Order
                    </button>
                    <button 
                        style={{ backgroundColor: "var(--successColor)", color: "#FFF", padding: '15px 0'}}
                        onClick={() => setConfirmClose(currentOrder?.status === "accepted" ? "in prep" : "closed")}
                        disabled={currentOrder?.status === "cancelled" || currentOrder?.status === "rejected"}
                    >
                        {currentOrder?.status === "accepted" ? "Set Order In Prep" : "Close Order"}
                    </button>
                </div>
            ))}
            {confirmClose && (
                <div className="backsplash">
                    <div id="confirm-card">
                        <h2>Are your sure you want to {confirmClose} this order.</h2>
                        <div id="bt-connect-wrapper">
                            <button 
                                onClick={() => setConfirmClose(null)}
                                style={{ backgroundColor: "var(--errorColor)", color: "#FFF", padding: '15px 0'}}
                            >
                                No, Go back
                            </button>
                            <button 
                                style={{ backgroundColor: "var(--successColor)", color: "#FFF", padding: '15px 0'}}
                                onClick={() => {
                                    if(confirmClose === "cancel") {
                                        onCancelOrder()
                                    } else {
                                        closeOrder()
                                    }
                                }}
                            >
                                Yes, Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}